import { Link } from "@mui/material";
import { FC, useEffect, useState } from "react";

import classes from "./LifecycleTable.module.scss";

const colors = {
  Optimize: "green",
  Adopt: "green",
  Use: "orange",
  Engage: "orange",
  Implement: "red",
  Onboard: "red",
};

const LifecycleTable: FC<{ data: any; idTag: string }> = ({ data, idTag }) => {
  const [workloads, setWorkloads] = useState<string[]>([]);

  useEffect(() => {
    const keysSet = new Set<string>();
    data?.subscriptions.forEach((sub: any) => {
      Object.keys(sub.lifecycleStageByWorkload).forEach((key) => {
        keysSet.add(key);
      });
    });
    setWorkloads(Array.from(keysSet).sort());
  }, [data]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        margin: "20px 0 20px 40px",
      }}
      id={idTag}
    >
      <Link
        target="_blank"
        rel="noopener noreferrer"
        href={
          "https://app.powerbi.com/groups/me/apps/4b9b445f-79c0-4b58-b04b-33a1aae5f68d/reports/783ed656-b961-4b01-9b23-d9e3559c2542/ReportSection39505f477abaea8fcfaf?ctid=5ae1af62-9505-4097-a69a-c1553ef7840e&experience=power-bi&clientSideAuth=0"
        }
        style={{ display: "flex", justifyContent: "end" }}
      >
        Lifecycle Power BI Report
      </Link>
      <div
        style={{
          maxHeight: "40vh",
          overflowY: "auto",
          borderTop: "2px solid #C0C0C0",
          borderBottom: "2px solid #C0C0C0",
        }}
      >
        <table className={classes.table}>
          <thead className={classes.thead}>
            <tr>
              <td
                className={` ${classes.commonThead}`}
                style={{
                  verticalAlign: "middle",
                }}
              >
                Account ID
              </td>
              <td
                className={` ${classes.commonThead}`}
                style={{
                  verticalAlign: "middle",
                }}
              >
                Subscription ID
              </td>

              {workloads.map((wk: string, idx: number) => (
                <td
                  key={wk}
                  className={classes.commonThead}
                  style={{ verticalAlign: "middle" }}
                >
                  {wk}
                </td>
              ))}

              {workloads.length === 0 && (
                <td className={` ${classes.commonThead}`}>No Workloads</td>
              )}
            </tr>
          </thead>
          <tbody className={classes.tbody}>
            {data?.subscriptions?.map((sub: any, idx: number) => (
              <tr
                key={sub.subscriptionKey}
                className={classes.subBorder}
              >
                {sub?.accountKey === data?.subscriptions?.[idx - 1]?.accountKey ? null : (
                  <td
                    rowSpan={
                      data?.subscriptions?.filter((a: any) => a?.accountKey === sub?.accountKey)
                        ?.length ?? 1
                    }
                    className={`${classes.commonTd} ${classes.subBorder}`}
                  >
                    {sub.accountId}
                  </td>
                )}

                <td className={` ${classes.commonTd}`}>{sub?.subscriptionId ?? "-"}</td>

                {workloads.map((wk: string, idx: number) => (
                  <td
                    className={` ${classes.commonTd}`}
                    key={idx}
                    style={{
                      color: sub?.lifecycleStageByWorkload?.[wk]
                        ? colors[sub.lifecycleStageByWorkload[wk] as keyof typeof colors]
                        : "black",
                    }}
                  >
                    {sub?.lifecycleStageByWorkload?.[wk] ?? "-"}
                  </td>
                ))}

                {workloads.length === 0 && <td className={` ${classes.commonTd}`}>{"-"}</td>}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LifecycleTable;
